import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient } from '@angular/common/http';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';
import { IPackage, Package } from '../models/package.model';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';
import { IPackagesResponse, PackagesResponse } from '../models/packages-response.model';

@Injectable({
  providedIn: 'root'
})
export class PackageService {

  public loading: boolean = false;
  public packages: PackagesResponse = new PackagesResponse({ 
    pending: [], 
    historical: [] 
  });

  constructor(
    public authService: AuthService,
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR get                                 */
  /* -------------------------------------------------------------------------- */
  // region get
  async get(
    packageItem: Package
  ): Promise<Package | undefined> {

    let packageResult: Package | undefined;

    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando paquete';

    const urlApi = `${environment.urlApi}/neighborhoods/${packageItem.neighborhoodId}/packages/${packageItem.packageId}`;

    try {

      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse<{ package: IPackage }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ package: IPackage }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ package: IPackage }>
              ) => resolve(
                new ServerResponse<{ package: IPackage }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {

        packageResult = new Package(response.data!.package);

      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {

      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );

    } finally {

      this.spinnerService.loading = false;
      this.spinnerService.message = '';

    }

    return packageResult;

  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR getAll                               */
  /* -------------------------------------------------------------------------- */
  // region getAll
  async getAll(
    neighborhoodId: string
  ) {

    this.loading = true;

    const urlApi = `${environment.urlApi}/neighborhoods/${neighborhoodId}/packages`;


    try {

      const token = await this.authService.getToken();

      const response = await new Promise<ServerResponse<IPackagesResponse>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<IPackagesResponse>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token.toString()
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<IPackagesResponse>
              ) => resolve(
                new ServerResponse<IPackagesResponse>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {

        this.packages = new PackagesResponse(response.data!);

      } else {

        this.toastService.show(
          {
            header: 'Error de servidor',
            body: `${response.message}`,
            classname: 'bg-danger text-white'
          }
        );

      }

    } catch(error) {

      console.log(error);

      this.toastService.show(
        {
          header: 'Error',
          body: `${error}`,
          classname: 'bg-danger text-white'
        }
      );

    } finally {

      this.loading = false;

    }

  }


}
